/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Faq_4_QuestionInputs */

const en_svc_integration_faq_4_question = /** @type {(inputs: Svc_Integration_Faq_4_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do you also offer AI consulting?`)
};

const lv_svc_integration_faq_4_question = /** @type {(inputs: Svc_Integration_Faq_4_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai piedāvājat arī AI konsultācijas?`)
};

/**
* | output |
* | --- |
* | "Do you also offer AI consulting?" |
*
* @param {Svc_Integration_Faq_4_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_faq_4_question = /** @type {((inputs?: Svc_Integration_Faq_4_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Faq_4_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_faq_4_question(inputs)
	return en_svc_integration_faq_4_question(inputs)
});